export default __webpack_public_path__ + "static/media/select-icon.2af58a19.svg";